import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { ShortMessageTemplatesActions } from './partials/templates'

export const ShortMessageActions = {
  ...ShortMessageTemplatesActions,

  async sendTextMessage (_, { message, recipient }) {
    return await axiosRequest.
      post('/short_messages/send_text_message', { message, recipient }).
      catch(handleError)
  },
}
